import React from 'react';
import PropTypes from 'prop-types';
import handleKeyPress from '../../common/handleKeyPress';
import * as Styled from './styles';

const Tab = ({ isActive, label, onClick }) => (
    <Styled.TabDiv
        data-test-id={label}
        data-tip
        data-for={label}
        isActive={isActive}
        onClick={onClick}
        onKeyDown={(e) => handleKeyPress(e, () => onClick(e))}
        role="button"
        aria-label={`${label} mode`}
        aria-pressed={isActive}
        tabIndex={0}
    >
        <Styled.TabNameDiv>{label}</Styled.TabNameDiv>
    </Styled.TabDiv>
);

Tab.propTypes = {
    isActive: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default Tab;
